import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const vinculoTransporteReducer = (state = InitialState.vinculoTransporteReducer, action) => {
    switch (action.type) {
        case ActionType.GET_VINCULO_TRANSPORTE_RESPONSE: {
            return {
                ...state,
                vinculoTransporteObject: _.assign(action.vinculoTransporteObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default vinculoTransporteReducer;